// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/poi_search.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { PoiSearchService } from "./poi_search_pb";

/**
 * SearchPois returns active POIs in a city matching the filters, name-ordered.
 *
 * @generated from rpc travplaces.v1.PoiSearchService.SearchPois
 */
export const searchPois = PoiSearchService.method.searchPois;
